import React from 'react';

import { IonContent, IonPage, IonSpinner, withIonLifeCycle } from '@ionic/react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchProjectIfNeeded } from '../helpers/ensureRouteHierarchy';
import store, { RootState, actions } from '../store/index';

import Header from '../components/Header/Header';
import EditProjectForm from '../components/EditProject/EditProjectForm';
import ProjectFooter from '../components/Project/ProjectFooter';

class PageEditProject extends React.Component<any, any> {
  abortController = new AbortController();

  constructor(props: any) {
    super(props);

    this.state = {
      isSubmitting: false,
      isValid: false,
      isDeleting: false,
      isFetching: true,
    };

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.updateProject = this.updateProject.bind(this);
    this.disableSubmit = this.disableSubmit.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  async ionViewWillEnter() {
    this.setState({ isFetching: true });
    try {
      await fetchProjectIfNeeded(
        this.props.match.params.id,
        this.abortController.signal,
        this.props.setCurrentProject,
      );
    } catch {
      // ignore
    }
    this.setState({ isFetching: false });
  }

  onChangeHandler(isValid: boolean) {
    this.setState({ isValid });
  }

  updateProject() {
    this.setState({ isSubmitting: true });
  }

  disableSubmit() {
    this.setState({ isSubmitting: false });
  }

  deleteProject(isDeleting: boolean) {
    this.setState({ isDeleting });
  }

  render() {
    const { project, user, history } = this.props;
    const { isAdmin } = store.getState().user;

    if (this.state.isFetching) {
      return (
        <IonPage>
          <IonContent className="page-wrapper">
            <IonSpinner name="crescent" color="primary" />
          </IonContent>
        </IonPage>
      );
    }

    return (
      <IonPage>
        <Header
          componentLeft="back"
          title={project.name}
          componentRight="saveProject"
          componentRightHandler={this.updateProject}
          componentSettings={this.state}
        />
        <IonContent>
          <EditProjectForm
            project={this.props.project}
            isSubmitting={this.state.isSubmitting}
            onChangeHandler={this.onChangeHandler}
            user={user}
            history={history}
            disableSubmit={this.disableSubmit}
            isDeleting={this.state.isDeleting}
            setDeleteState={this.deleteProject}
          />
        </IonContent>

        {isAdmin && <ProjectFooter
                      updateProject={this.updateProject}
                      deleteProject={this.deleteProject} />}
      </IonPage>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    project: state.currentProject,
    user: state.user,
  };
};

const mapDispatchToProps = {
  setCurrentProject: (project: any) =>
    actions.currentProject.setCurrentProject(project),
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withIonLifeCycle(PageEditProject)),
);

// const ConnectedPageEditProject = connect(mapStateToProps)(PageEditProject);
// const PageEditProjectWithRouter = withRouter(ConnectedPageEditProject);

// export default PageEditProjectWithRouter;
